import { render, staticRenderFns } from "./add-dia-letivo.vue?vue&type=template&id=2dd03859"
import script from "./add-dia-letivo.vue?vue&type=script&lang=js"
export * from "./add-dia-letivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports